<template lang="html">
    <div class="clients">
        <top-nav></top-nav>
        <page-title :title="getText('sites_title')" icon="location"></page-title>

        <div class="actions-bar">
            <div class="container">
                <el-row :gutter="24">
                    <el-col :span="8">
                        <div class="main-action-wrapper">
                            <router-link :to="{ name: 'site' }">
                                <el-button class="addButton greenButton">{{getText('sites_add_button')}}</el-button>
                            </router-link>
                        </div>
                    </el-col>
                    <el-col :span="8">
                        <div class="layout-display">
                            <span
                                @click="showGrid"
                                class="icon icon-layout-table"
                                :class="{ active: displayGrid }"
                            ></span>
                            <span
                                @click="showTable"
                                class="icon icon-layout-grid"
                                :class="{ active: !displayGrid }"
                            ></span>
                        </div>
                    </el-col>
                    <el-col :span="8">
                        <el-input :placeholder="getText('sites_search_bar')" class="researchField" v-model="filter">
                        </el-input>
                    </el-col>
                </el-row>
            </div>
        </div>

        <div class="viveco-footer-background">

            <div v-if="!displayGrid" class="cards-list">
                <div class="container">
                    <el-row :gutter="24">
                        <el-col
                            v-for="client in sortedFilteredClients"
                            :key="client.uid"
                            :xs="24"
                            :sm="8"
                        >
                            <el-card class="card-1-cta">

                                <router-link class="edit-btn" :to="{ name: 'site', params: { uid: client.uid } }">
                                    <span class="icon-edit"></span>
                                </router-link>

                                <div class="archive-site-btn">
                                    <el-button
                                        class="button"
                                        @click="toggleArchiving(client)"
                                        type="info"
                                        icon="el-icon-delete"
                                        circle
                                    ></el-button>
                                </div>

                                <div slot="header">
                                    <div class="title">{{client.name}}</div>
                                </div>
                                <div>
                                    {{client.addresse}}
                                </div>
                                <div>
                                    <router-link :to="{ name: 'moteurs', params: { siteid: client.uid } }">
                                        <el-button class="cardSelect greenButton">{{getText('sites_choose_button')}}</el-button>
                                    </router-link>
                                </div>
                            </el-card>
                        </el-col>
                    </el-row>
                </div>
            </div>

            <div v-else class="table">
                <table-component
                    :data="sortedFilteredClients"
                    :show-filter="false"
                    :show-caption="false"
                    sort-by="name"
                    sort-order="asc"
                >
                    <table-column show="name" :label="this.getText('sites_tab_name')"></table-column>
                    <table-column show="comment" :label="this.getText('sites_tab_comment')"></table-column>
                    <table-column :sortable="false" :filterable="false" :label="this.getText('sites_tab_archive')">
                        <template slot-scope="row">
                            <div class="archive">
                                <el-button
                                    class="archive-button"
                                    @click="toggleArchiving(row)"
                                    type="info"
                                    icon="el-icon-delete"
                                    circle
                                ></el-button>
                            </div>
                        </template>
                    </table-column>
                    <table-column  :sortable="false" :filterable="false" :label="this.getText('sites_tab_update')">
                        <template slot-scope="row">
                            <router-link :to="{ name: 'site', params: { uid: row.uid } }" class="table-icon-link">
                                <span class="icon icon-edit"></span>
                            </router-link>
                        </template>
                    </table-column>
                    <table-column :sortable="false" :filterable="false" :label="this.getText('sites_tab_choose')">
                        <template slot-scope="row">
                            <router-link :to="{ name: 'moteurs', params: { siteid: row.uid } }" class="table-icon-link">
                                <span class="icon icon-eye"></span>
                            </router-link>
                        </template>
                    </table-column>
                </table-component>
            </div>
            <el-dialog
                :title="getText('sites_archiving_title')"
                :visible.sync="archivingSite"
                width="30%"
                @close="siteBeingArchived = {}"
            >
                <div>{{getText('sites_archiving_desc')}}</div>
                <span slot="footer">
                    <div class="dialogButtons">
                        <el-button
                            class="cancel whiteButton"
                            v-loading="dialogLoading"
                            @click="archivingSite = false"
                        >{{getText('cancel_button')}}</el-button>
                        <el-button
                            v-loading="dialogLoading"
                            type="primary"
                            @click="archiveSite"
                            class="save greenButton"
                        >{{getText('dialog_confirm_archive_button')}}</el-button>
                    </div>
                </span>
            </el-dialog>

        </div>

        <page-footer></page-footer>
    </div>
</template>

<script>
import topNav from '../ui/top-nav.vue';
import pageTitle from '../ui/page-title.vue';
import pageFooter from '../ui/page-footer.vue';
import schwartz from 'schwartz';
import {mapGetters} from 'vuex';

export default {
    data () {
        return {
            displayGrid: false,
            filter: '',
            clients: this.sortedFilteredClients,
            archivingSite: false,
            dialogLoading: false
        };
    },
    computed: {
        ...mapGetters([
            'getText',
            'factories'
        ]),
        filteredClients() {
            let factoriesNotArchived = JSON.parse(JSON.stringify(this.factories)).filter(factory => factory.archived === false);

            if (this.filter.length) {
                let filter = this.filter.toLowerCase();
                let filteredArray = factoriesNotArchived.filter(function(item){
                    if ((item.archived === false && item.name && item.name.toLowerCase().indexOf(filter) !== -1) || (item.comment && item.comment.toLowerCase().indexOf(filter) !== -1)) {
                        return item;
                    }
                });
                return filteredArray;
            } else {
                return factoriesNotArchived;
            }
        },
        sortedFilteredClients() {
            return schwartz(this.filteredClients, client => client.creation_date).reverse();
        },
    },
    methods: {
        showGrid() {
            this.displayGrid = true;
        },
        showTable() {
            this.displayGrid = false;
        },
        toggleArchiving(site) {
            this.archivingSite = true;
            this.siteBeingArchived = site;
        },
        archiveSite() {
            this.dialogLoading = true;
            this.$store.dispatch('patchItem', {
                item : {
                    url: this.siteBeingArchived.url,
                    archived: true
                },
                model: 'factories',
            }).then(() => {
                this.$notify.success({
                    message: this.getText('notify_site_delete_successful'),
                });
                this.archivingSite = false;
                this.siteBeingArchived = {};
            }).catch((error) => {
                this.$notify.error({
                    message: this.getText('notify_site_delete_failed'),
                });
                console.error(error);
            }).finally(() => {
                this.dialogLoading = false;
            });
        }
    },
    components: {
        topNav,
        pageTitle,
        pageFooter
    },
};
</script>

<style lang="less">
@import '../../less/variables';
.clients {
    .table table {
        width: 100%;
        .archive {
            text-align: center;
            margin-top: 0;
            .archive-button {
                width: 30px;
                background-color: #CCCCCC;
                border: none;
                padding: 7px 6px 7px 7px;
                &:hover {
                    background-color: @color-1 !important;
                }
            }
        }
    }
    .actions-bar {
        padding-bottom: 30px;
    }
    .card-1-cta.el-card {
        height: 225px;
    }
}

.addButton {
    margin-bottom: 20px;
}
.researchField {
    margin-top: 20px;
    input {
        border-top: none;
        border-left: none;
        border-right: none;
        border-radius: 0;
        transition-duration: 0.4s;
        &:focus {
            border-bottom-color: @color-1 !important;
            border-bottom-width: 2px !important;
        }
    }
}
.cardSelect {
    margin-top: 50px;
    width: 100%;
    margin-right: auto !important;
    margin-left: auto !important;
}

.title {
    font-size: 20px;
}
</style>



// WEBPACK FOOTER //
// src/components/page/sites.vue